module.exports = __webpack_public_path__ + "static/media/litigio.ecc1de85.png";